import axios from 'axios';
import {
  getAllRewardsURL,
  GetAnnouncedGiftsProductsListUrl,
  getgiftDetailUrl,
  GetMyRetailersGiftTransactionsUrl,
  giftHistoryUrl,
  sendOTPforGiftUrl,
  UploadGiftImageUrl,
  verifyOTPforGiftUrl,
} from '../url';
import { getToken, getTokenHeader } from '../../../../../screen/auth/action';

export const GetAnnouncedGiftsProductsList = async (data) => {
  return new Promise(async (next) => {
    let token = await getToken();
    await axios
      .post(
        `${GetAnnouncedGiftsProductsListUrl()}`,
        data,
        getTokenHeader(token),
      )
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return next({ error: err });
      });
  });
};
export const GetMyRetailersGiftTransactionsList = async (data) => {
  return new Promise(async (next) => {
    let token = await getToken();

    await axios
      .get(`${GetMyRetailersGiftTransactionsUrl()}`, getTokenHeader(token))
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return next({ error: err });
      });
  });
};
export const getAllRewardsAction = async (data) => {
  return new Promise(async (next) => {
    let token = await getToken();
    const { start_date, end_date, type } = data;
    const queryParams = new URLSearchParams();
    if (start_date) queryParams.append('start_date', start_date);
    if (end_date) queryParams.append('end_date', end_date);
    if (type) queryParams.append('type', type);

    const url = `${getAllRewardsURL()}?${queryParams.toString()}`;
    await axios
      .get(url, getTokenHeader(token))
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return next({ error: err });
      });
  });
};
export const getgiftDetailAction = async (gift_id, type) => {
  return new Promise(async (next) => {
    let token = await getToken();
    const queryParams = new URLSearchParams();
    const url = `${getgiftDetailUrl()}?id=${gift_id}&type=${type}`;
    await axios
      .get(url, getTokenHeader(token))
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return next({ error: err });
      });
  });
};
export const sendOTPforGiftAction = async (gift_id, type) => {
  return new Promise(async (next) => {
    let token = await getToken();
    const queryParams = new URLSearchParams();
    const url = `${sendOTPforGiftUrl()}?gift_id=${gift_id}&type=${type}`;
    await axios
      .get(url, getTokenHeader(token))
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return next({ error: err });
      });
  });
};
export const verifyOTPforGiftAction = async (gift_id, otp, type) => {
  return new Promise(async (next) => {
    let token = await getToken();
    const payload = {
      gift_id: gift_id,
      otp: otp,
      type: type,
    };
    await axios
      .patch(verifyOTPforGiftUrl(), payload, getTokenHeader(token))
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return next({ error: err });
      });
  });
};
export const getGiftHistoryAction = async (reciever_id, type) => {
  return new Promise(async (next) => {
    let token = await getToken();
    const queryParams = new URLSearchParams();
    const url = `${giftHistoryUrl()}?company_id=${reciever_id}&type=${type}`;
    await axios
      .get(url, getTokenHeader(token))
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return next({ error: err });
      });
  });
};
export const UploadGiftImage = async (payload) => {
  return new Promise(async (next) => {
    let token = await getToken();
    await axios
      .post(
        `${UploadGiftImageUrl()}`,
        payload,
        getTokenHeader(token),
      )
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return next({ error: err });
      });
  });
};

